import angular from 'angular';
import uiRouter from 'angular-ui-router';
import businessesComponent from './businesses.component';

let businessesModule = angular.module('app.containers.businesses', [
  uiRouter,
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('businesses', {
      url: '/businesses',
      template: '<businesses></businesses>'
    })
})

.component('businesses', businessesComponent);

export default businessesModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/businesses/businesses.js
 **/